module.exports = __webpack_public_path__ + "img/team_star.9348f8ee.svg";